import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface WorkflowCartRowProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export const WorkflowCartRow = ({ title, subtitle, actions }: WorkflowCartRowProps) => (
  <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between">
    <Box>
      {typeof title === 'string' ? (
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      ) : (
        title
      )}
      {subtitle ? (
        typeof subtitle === 'string' ? (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        ) : (
          subtitle
        )
      ) : null}
    </Box>
    {actions ? <Box sx={{ display: 'flex', alignItems: 'center' }}>{actions}</Box> : null}
  </Stack>
);
